import * as React from 'react'

import { Button } from '~/client/src/shared/components/shadcn-ui/button'
import { NOOP } from '~/client/src/shared/utils/noop'

// localization: no display text to translate

interface IProps {
  title: string
  onClick: () => void
  isEnabled: boolean
}

export default class ActionHandleButton extends React.PureComponent<IProps> {
  public static defaultProps = {
    onClick: NOOP,
  }

  public render() {
    const { title, onClick, isEnabled } = this.props

    return (
      <Button
        variant={isEnabled ? 'default' : 'outline'}
        onClick={onClick}
        className={isEnabled ? undefined : 'tw:cursor-not-allowed'}
      >
        {title}
      </Button>
    )
  }
}
